<template>
	<Container :active='3'>
		<template v-for='modular in modulars'>
			<div class="carousel" v-if='modular.MediaType == "banner"'>
				<Carousel v-model="value1" loop autoplay :autoplay-speed='8000' dots='none'>
			        <CarouselItem v-for='item in modular.items'>
			            <a :href='configUrl(item)' class="carousel-item">
							<img class="img" :src="item.Pic">
						</a>
			        </CarouselItem>
			    </Carousel>
			    <div class="indicator">
			    	<div class="dots">
				    	<div class="dot" @mouseenter='value1=i - 1' :class='{active:i - 1==value1}' v-for='i in modular.items.length'></div>
				    </div>
			    </div>
			</div>
			<div class="college" v-else-if='modular.MediaType == "article"'>
				<div class="head">
					<div class="title">{{modular.Name}}</div>
					<a :href='modular.MoreUrl' class="more">查看更多>></a>
				</div>
				<div class="items">
					<div class="item" v-for='(item,i) in modular.items' :key='i + "college"'>
						<p class="title">{{item.Title}}</p>
						<p class="datetime">{{item.ValidFrom.replace('T',' ')}}</p>
						<p class="content">{{item.SubTitle}}</p>
						<a :href='configUrl(item)' class="button-primary detail">{{item.Flag2 || '查看詳情'}}</a>
					</div>
				</div>
			</div>
			<div class="online-course" v-else-if='modular.MediaType == "learning"'>
				<div class="head">
					<div class="title">{{modular.Name}}</div>
					<a :href='modular.MoreUrl' class="more">查看更多>></a>
				</div>
				<div class="items">
					<template v-for='(item,index) in modular.items'>
						<a :href='configUrl(item)' class="item l-item" v-if='index == 0'>
							<img class="cover" v-lazysrc="item.Pic" :data-default='require("@/assets/defaultImg.png")'>
							<img class="play" src="@/assets/play.png">
							<p class="desc">{{item.Title}}</p>
						</a>
						<a :href='configUrl(item)' v-else class="item s-item" :key='index+"item"'>
							<div class="zoom-out">
								<img class="cover" v-lazysrc="item.Pic" :data-default='require("@/assets/defaultImg.png")'>
								<img class="play" src="@/assets/play.png">
								<p class="desc">{{item.Title}}</p>
							</div>
						</a>
					</template>
				</div>
			</div>
		</template>
		
	</Container>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				value1:0,
				modulars:[],
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {
		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				'getPageConfigAction',
				'getPageConfigDetailAction',
			]),
			async initData(){
				let modulars = await this.getPageConfigAction('WSCommunity')
				let response1 = await this.getPageConfigDetailAction({page:'WSCommunity'})
				modulars.forEach(modular=>{
					let items = response1.filter(item=>item.Module == modular.Code)
					modular.items = items
				});
				this.modulars = modulars;
			},
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/common';
	@import '@/style/mixin';
	
	.college {
		margin: 0 10vw;
		margin-top: 0.4rem;
		.item {
			margin:0 0.2rem;
			margin-bottom: 0.4rem;
			border-bottom: 1px solid #eee;
			.title {
				color:$theme-color;
				@include fontSize($font-size-18);
				margin-bottom: 5px;
			}
			.datetime,.content {
				margin-bottom: 5px;
			}
			.detail {
				background-color: $theme-color;
				color:white;
				display: inline-block;
				padding: 3px 10px;
				border-radius: 20px;
				margin-top: 0.2rem;
				margin-bottom: 0.2rem;
			}
		}
	}
	.online-course {
		margin: 0 10vw;
		margin-bottom: 40px;
		.items {
			display: flex;
			flex-wrap: wrap;
			.item {
				position: relative;
				overflow: hidden;
				div {
					display: flex;
					justify-content: center;
					align-items: center;
					cursor: pointer;
				}
				.cover {
					width:100%;
					height:100%;
					object-fit: cover;
				}
				.play {
					position:absolute;
					width:2.6vw;
					height:2.6vw;
				}
				.desc {
					background-color: rgba(0,0,0,0.3);
					color:#fff;
					position:absolute;
					bottom: 0;
					width:100%;
					text-align: center;
					font-weight: bold;
					line-height: 30px;
				}
				
			}
			.l-item {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 79.17vw;
				height:34.9vw;
				border-radius: 20px;
				margin-top: 2.6vw;
				.play {
					position:absolute;
					width:5vw;
					height:5vw;
				}
			}
			.s-item {
				// height:10vw;
				flex:1;
				min-width: 200px;
				min-height: 128px;
				margin-top: 1.56vw;
				div {
					border-radius: 10px;
					overflow: hidden;
					position: relative;
					margin: 0 1.56vw;
				}
				
			}
		}
	}
	.head {
		position: relative;
		text-align: center;
		align-items: center;
		display:flex;
		justify-content: center;
		.title {
			background-color:$theme-color;
			color:white; 
			padding: 3px 30px;
			border-radius: 40px;
			@include fontSize($font-size-24);
			font-weight: bold;
			display: inline-block;
			text-align: center;
		}
		.more {
			position: absolute;
			right: 0;
		}
	}
	@media (max-width: 768px){
		.college,.online-course { 
			margin: 0 5vw;
			margin-top: 0.4rem;
		}
		.head {
			margin-bottom: 10px;
		}
		.online-course {
			.items {
				.item {
					.play {
						width: 40px;
						height:40px;
					}
					.desc {
						line-height: 25px;
					}
				}
				.l-item {
					width: 95vw;
					height:50vw;
				}
				.s-item {
					width: 45vw;
					min-width:auto;
					flex:auto;
					min-height: auto;
					margin-top: 10px;
					@include fontSize($font-size-12);
				}
			}
		}
	}
</style>